export class DeepLinkRouteData
{
    ModuleName :string ='';
    MappedRoute :string ='';
    MenuKey : string ='';
    SubMenuKey : string ='';
}